export const FIRM_DOCUMENT_FOLDERS_QUERY_KEY = 'firm-document-folders';
export const FIRM_DOCUMENT_FOLDERS_QUERY_STALE_TIME_MS = 60_000;
